import React, { forwardRef } from 'react';
import { useCurrentRefinements } from 'react-instantsearch';
import FilterIcon from '~/icons/filter.svg';
import { Button } from '~/shared/components';
import { CountBadge } from '~/features/productList/components/CountBadge';
import ITrigger from './Trigger.definitions';
import styles from './Trigger.module.scss';

const Trigger = forwardRef<HTMLButtonElement, ITrigger>(({ label, handleToggle }, ref) => {
    const { items: currentRefinements } = useCurrentRefinements();
    const activeFilterCount = currentRefinements.reduce(
        (sum, item) => sum + item.refinements.length,
        0,
    );

    return (
        <div className={styles.triggerWrapper}>
            <Button ref={ref} onClick={handleToggle} size="small" variant="inverse-plp" fullWidth>
                <FilterIcon />
                {label}
                <CountBadge count={activeFilterCount} />
            </Button>
        </div>
    );
});

Trigger.displayName = 'Trigger';

export default Trigger;
